/*
 | Bundle JS de la web pública (hostsuar.com y docs.hostsuar.com).
 |
 | Independiente de app.js (área de clientes y admin): aquí solo entra lo que la
 | web usa de verdad. Livewire y Alpine son necesarios para el carrito, los
 | buscadores de dominio y el formulario de multicuenta.
 */
import { Livewire, Alpine } from "../../vendor/livewire/livewire/dist/livewire.esm";
import focus from "@alpinejs/focus";
import registerDocs from "./docs";
import { trackFathomViewsOnLoad } from "./fathom-views";
import registerNav from "./site/nav";
import registerSpotlight from "./site/spotlight";
import registerMagnet from "./site/magnet";
import billing from "./site/billing";
import installerDemo from "./site/installer";
import rotator from "./site/rotator";
import registerCheckoutEntry from "./site/checkout-entry";

Alpine.plugin(focus);
registerDocs(Alpine);

// Componentes Alpine de la web (los usan los <x-site.*>).
Alpine.store("billing", billing);
Alpine.data("installerDemo", installerDemo);
Alpine.data("rotator", rotator);

window.Alpine = Alpine;

/*
 | Micro-interacciones del rediseño. Todas delegan en document o se enganchan a
 | window, así que da igual el orden respecto a Livewire.
 */
function registerBehaviours() {
    registerNav();
    registerSpotlight();
    registerMagnet();
    registerCheckoutEntry();
}

/*
 | Analítica: Fathom. Los enlaces marcan el evento con data-fathom-event y las
 | secciones que cuentan como impresión con data-fathom-view.
 */
function trackFathomEvent(name) {
    if (name && window.fathom) {
        window.fathom.trackEvent(name);
    }
}

function registerFathom() {
    document.addEventListener("click", (event) => {
        const element = event.target instanceof Element ? event.target.closest("[data-fathom-event]") : null;

        if (element) {
            trackFathomEvent(element.dataset.fathomEvent);
        }
    });

    trackFathomViewsOnLoad();
}

function boot() {
    registerBehaviours();
    registerFathom();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
} else {
    boot();
}

Livewire.start();
